import React from 'react';
import { getInteractiveOptions } from '../utils/whatsappInteractive';

export default function WhatsAppInteractiveOptions({ message }) {
    const options = getInteractiveOptions(message);
    if (!options.length) return null;
    return (
        <div className="mt-3 space-y-1.5" aria-label="Opciones enviadas al cliente">
            <p className="text-[10px] text-slate-400">Opciones enviadas al cliente</p>
            <ul className="space-y-1.5">
                {options.map((option, index) => (
                    <li key={index} className="rounded-lg border border-emerald-500/30 bg-emerald-500/5 px-3 py-2 text-center text-xs text-emerald-300 break-words">
                        {option.title}
                        {option.description && <span className="mt-1 block text-slate-400">{option.description}</span>}
                    </li>
                ))}
            </ul>
        </div>
    );
}
